// extracted by mini-css-extract-plugin
export default {"number":"CompanyInvoicesTableView_number__uHm7K","tableWrapper":"CompanyInvoicesTableView_tableWrapper__64n2x","checkedStatus":"CompanyInvoicesTableView_checkedStatus__AlUkF"};